"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="26951" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-24 bg-muted-foreground/10 animate-pulse rounded-sm" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-white transition-colors text-sm font-medium">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function ClinicFooter() {
  const currentYear = new Date().getFullYear();
  return <footer id="footer" className="bg-primary pt-16 pb-8 text-primary-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1601078/img/lavers_logo_footer.png" alt="Lavers Business Consulting" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs font-sans tracking-tight">
              Over a decade of consulting expertise focused on making businesses more efficient, cutting costs, and driving sustainable revenue growth.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-bold text-white text-lg tracking-tighter">Strategic Links</h3>
            <MenuProvider menu_id="17" className="w-full">
              <FooterLinks />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-bold text-white text-lg tracking-tighter">Our Office</h3>
            <ul className="flex flex-col gap-3 text-sm text-muted-foreground font-sans">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#2dbd7e] mt-0.5 shrink-0" />
                <div className="flex flex-col gap-1">
                  <span className="font-medium text-white">Latrobe Headquarters</span>
                  <span className="font-semibold text-[#2dbd7e]">20 Spring GR, TAS 7308</span>
                </div>
              </li>
              <li className="pl-7 text-xs opacity-80 uppercase tracking-widest font-mono">
                Australia
              </li>
              <li className="flex items-center gap-3">
                <div className="w-4 flex justify-center shrink-0">
                  <Phone className="w-3.5 h-3.5 text-[#2dbd7e]" />
                </div>
                <span>0468075702</span>
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-bold text-white text-lg tracking-tighter">Newsletter</h3>
            <ul className="flex flex-col gap-4 text-sm text-muted-foreground font-sans">
              <li className="flex items-start gap-3 group">
                <Mail className="w-4 h-4 text-[#2dbd7e] mt-1 shrink-0 group-hover:text-white transition-colors" />
                <span className="leading-relaxed">
                  Subscribe for efficiency insights and growth strategies.
                </span>
              </li>
              <li className="flex items-center gap-3 group">
                <Linkedin className="w-4 h-4 text-[#2dbd7e] shrink-0 group-hover:text-white transition-colors" />
                <Link to="https://linkedin.com" className="hover:text-white transition-colors">
                  Join our professional network
                </Link>
              </li>
              <li className="flex items-center gap-3 group">
                <Clock className="w-4 h-4 text-[#2dbd7e] shrink-0 group-hover:text-white transition-colors" />
                <Link to="/ConsultationPage" className="hover:text-white transition-colors">
                  Book a strategy session
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="bg-border/10 mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-muted-foreground font-sans">
          <p>
            &copy; {currentYear} Lavers Business Consulting. Precision & Profit.
          </p>
          
          <div className="flex items-center gap-4">
            <Link to="https://instagram.com" newTab className="p-2 rounded-sm hover:bg-[#1e293b] hover:text-white hover:shadow-md transition-all duration-300 text-muted-foreground" aria-label="Instagram">
              <Instagram className="w-5 h-5" />
            </Link>
            <Link to="https://facebook.com" newTab className="p-2 rounded-sm hover:bg-[#1e293b] hover:text-white hover:shadow-md transition-all duration-300 text-muted-foreground" aria-label="Facebook">
              <Facebook className="w-5 h-5" />
            </Link>
            <Link to="https://linkedin.com" newTab className="p-2 rounded-sm hover:bg-[#1e293b] hover:text-white hover:shadow-md transition-all duration-300 text-muted-foreground" aria-label="LinkedIn">
              <Linkedin className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}